<template>
  <b-row class="mt-4 justify-content-md-center">
    <b-col cols="8">
      <h3>Signing Out...</h3>
    </b-col>
  </b-row>
</template>

<script>
/*
  This page is showed when the user is signing out
*/

import router from '@/router'

export default {
  async created () {
    // call the authentication method for signing out the user
    this.$store.dispatch('auth/signOut')
    // go to the home page
    router.push({ name: 'home' }).catch(err => console.error(err))
  }
}
</script>
